import { getTranslate } from '@/legacy-src/utilities/i18n'

import { Button } from '@/src/domains/design-system/components/Button'
import { Heading } from '@/src/domains/design-system/components/Heading'
import { Text } from '@/src/domains/design-system/components/Text'
import { useFreeSlotTypeQueryFilter } from '@/src/domains/client-booking/hooks/useFreeSlotTypeQueryFilter'

export const ClientBookingAvailableSlotsEmpty = () => {
  const { pushFilter } = useFreeSlotTypeQueryFilter()

  const { t } = getTranslate()

  return (
    <section className="flex h-full w-full flex-col items-center justify-center text-center">
      <Heading element="h2" variant="xl" className="mb-5 max-w-[21rem]">
        {t('component.calendar.noAvailableSlots.offline.title')}
      </Heading>
      <Text element="p" className="mb-8 max-w-[21rem]">
        {t('component.calendar.noAvailableSlots.offline.description')}
      </Text>
      <Button size="small" onClick={() => pushFilter(null)}>
        {t('component.calendar.noAvailableSlots.offline.cta')}
      </Button>
    </section>
  )
}
